/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Signin_HeadingInputs */

const en_invite_signin_heading = /** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to join`)
};

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const ar_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const he_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const ur_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const es_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const fr_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const de_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const pt_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const hi_invite_signin_heading = en_invite_signin_heading;

/** @type {(inputs: Invite_Signin_HeadingInputs) => LocalizedString} */
const bn_invite_signin_heading = en_invite_signin_heading;

/**
* | output |
* | --- |
* | "Sign in to join" |
*
* @param {Invite_Signin_HeadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_signin_heading = /** @type {((inputs?: Invite_Signin_HeadingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Signin_HeadingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_signin_heading(inputs)
	if (locale === "he") return he_invite_signin_heading(inputs)
	if (locale === "ur") return ur_invite_signin_heading(inputs)
	if (locale === "es") return es_invite_signin_heading(inputs)
	if (locale === "fr") return fr_invite_signin_heading(inputs)
	if (locale === "de") return de_invite_signin_heading(inputs)
	if (locale === "pt") return pt_invite_signin_heading(inputs)
	if (locale === "hi") return hi_invite_signin_heading(inputs)
	if (locale === "bn") return bn_invite_signin_heading(inputs)
	return /** @type {LocalizedString} */ ("Sign in to join")
});